import { Box, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import classNames from 'classnames'
import { Icon } from 'packages/eid-icons'
import { useTranslation } from 'react-i18next'

const RequiredFieldErrorBox = styled(Box)({
    fontSize: '1.2rem',
    color: '#d0021b',
    display: 'flex',
    alignItems: 'center',
    marginTop: '0.8rem',
    paddingLeft: '0rem',
    gap: '.5rem',
    '& svg': {
        width: '1.2rem',
        height: '1.2rem',
    },
})

const RequiredFieldErrorMessage = ({
    errorMsgKey,
    showIcon = true,
    parentClass,
    sx = {},
}) => {
    const { t } = useTranslation()
    return (
        <RequiredFieldErrorBox className={classNames(parentClass)} sx={sx}>
            {showIcon && (
                <Icon name="Warning" color="#d0021b" fontSize="1rem" />
            )}
            <Typography variant="label">{t(errorMsgKey)}</Typography>
        </RequiredFieldErrorBox>
    )
}

export default RequiredFieldErrorMessage
